__webpack_require__.p = "https://assets.stitchfix.com/product-page-ui/packs/";